import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";

export default function ScrollToTop({ children }) {
  const location = useLocation();

  // useLayoutEffect(() => {
  //   if (location.pathname === '/entrar') {
      document.querySelector("link[rel*='icon']").href = '/fav-olga.png'
  //   } else {
  //     document.querySelector("link[rel*='icon']").href = '/fav.png'
  //   }
    
  // }, [location])

  useLayoutEffect(() => {
    const layoutDiv = document.querySelector("#layout");
    if (layoutDiv) {
      layoutDiv.scrollTo(0, 0);
    }
  }, [location.pathname]);

  return children;
}
